import { StatusNewSection } from "Status/StatusNewSction";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { useLoaderData } from "react-router";

const StatusNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.StatusNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <StatusNewSection
            mainArea={viewModel.mainArea}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              text: RESX.Buttons.ListView,
              href: routes.status_List(viewModel.mainArea).absolute,
              visible: true
            }]}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default StatusNewApp;